import React, { useCallback, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';
import DeletePopover from 'components/DeletePopover';
import { actions } from './Patients.redux';

const PatientCell = (params) => {
    const { row, field } = params;
    const id = row.patient_id;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const actionAnchor = useRef(null);
    const [actionsOpen, setActionsOpen] = useState(false);

    const beforeDeletePatient = useCallback(() => {
        dispatch(actions.setState({ loading: true }));
    }, [dispatch]);

    const afterDeletePatient = useCallback(() => {
        setActionsOpen(false);
        dispatch(actions.search());
    }, [dispatch]);

    const handleNavigate = useCallback(() => {
        navigate({ to: `/patients/view/${id}` });
    }, [navigate, id]);

    if (field === 'actions') {
        return (
            <>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(event) => {
                        event.stopPropagation();
                        setActionsOpen(true);
                    }}
                    ref={actionAnchor}
                >
                    ...
                </Button>
                <Menu open={actionsOpen} onClose={() => setActionsOpen(false)} anchorEl={actionAnchor.current}>
                    <MenuItem onClick={(event) => event.stopPropagation()}>
                        <DeletePopover
                            objectType="PATIENT"
                            objectID={id}
                            afterDelete={afterDeletePatient}
                            beforeDelete={beforeDeletePatient}
                        >
                            <Button variant="text" size="large" color="error">
                                Delete Patient
                            </Button>
                        </DeletePopover>
                    </MenuItem>
                </Menu>
            </>
        );
    }

    return <span onClick={handleNavigate}>{params.value ?? ''}</span>;
};

export default PatientCell;
